import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sw-quick-sidenav-contacts',
  templateUrl: './quick-sidenav-contacts.component.html',
  styleUrls: ['./quick-sidenav-contacts.component.scss'],
})
export class QuickSidenavContactsComponent implements OnInit {
  q: string = '';
  messages = [
    {
      time: '',
      message: '',
      from: {
        name: '',
        email: '',
        status: '',
        picture: '',
      },
    },
    {
      time: '',
      message: '',
      from: {
        name: '',
        email: '',
        status: '',
        picture: '',
      },
    },
    {
      time: '',
      message: '',
      from: {
        name: '',
        email: '',
        status: '',
        picture: '',
      },
    }
  ];

  constructor() {}

  ngOnInit() {}
}
